"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var HBNewTableSpacer = function HBNewTableSpacer(_ref) {
  var colSpan = _ref.colSpan,
    height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement(StyledTr, null, /*#__PURE__*/_react["default"].createElement(StyledTd, {
    colSpan: colSpan
  }, /*#__PURE__*/_react["default"].createElement(Spacer, {
    height: height
  })));
};
var _default = exports["default"] = HBNewTableSpacer; // --- Styles ---
var StyledTr = _styledComponents["default"].tr.withConfig({
  displayName: "HBNewTableSpacer__StyledTr",
  componentId: "sc-104xckt-0"
})([""]);
var StyledTd = _styledComponents["default"].td.withConfig({
  displayName: "HBNewTableSpacer__StyledTd",
  componentId: "sc-104xckt-1"
})([""]);
var Spacer = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTableSpacer__Spacer",
  componentId: "sc-104xckt-2"
})(["height:", "px;"], function (props) {
  return props.height;
});
//# sourceMappingURL=HBNewTableSpacer.js.map